import React from "react";
import Couple from "../components/Couple";
import styled from "styled-components";
import { HideMobile, ShowMobile } from "../components/blocks/Responsive";
import Helmet from "react-helmet";
import { P, H1, H2, H3, H4, H5 } from "../components/typography";
import { getGraphNode } from "../selectors";
import NavBar from "../components/NavBar";
import ContentSection from "../components/blocks/ContentSection";
import IconGrid from "../components/IconGrid";
import Emphasis from "../components/atoms/Emphasis";
import Section from "../components/blocks/Section";
import favicon from "../../assets/logofavcon@2x.png";
import ProductAnimationSlider from "../components/ProductAnimationSlider";
import ProductAnimationMobile from "../components/ProductAnimationMobile";

const AnimationSlider = styled.div`
  position: ${({ stage }) => (stage < 3 ? "fixed" : "absolute")};
  top: ${({ stage }) => (stage < 3 ? "20vh" : "auto")};
  bottom: ${({ stage }) => (stage < 3 ? "auto" : "0")};
  left: 0;
  right: 0;
  transform: translate3d(0, ${({ stage }) => (stage < 2 ? 0 : "-6vh")}, 0);
  transition: transform 500ms;
`;

const AnimationContainer = styled.div`
  padding: 5rem 0rem;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex-wrap: wrap-reverse;
  height: 170vh;
`;

const AnimationText = styled.div`
  padding: 3rem 1rem;
  min-width: 15rem;
  order: 1;
  flex: 3;
`;

const AnimationSVG = styled.div`
  order: 2;
  flex: 2;
`;

const BodyText = P.extend`font-size: 1.35rem;`;

export default class ProductPage extends React.Component {
  componentWillMount() {
    this.setState({
      ...this.state,
      waypointLocation: 0
    });
  }

  render() {
    const content = getGraphNode(this.props.data, "ProductPage");
    const missionContent = getGraphNode(this.props.data, "MissionPage");

    return (
      <div>
        <Helmet
          title="Contraline Product"
          meta={[
            {
              name: "Contraline",
              content: "Product"
            }
          ]}
        >
          <link rel="icon" type="image/png" href={favicon} />
        </Helmet>
        <NavBar color="white" background="teal" />
        <Section color="teal" padLarge={true}>
          <HideMobile>
            <H2 serif weight="bold" color="white" align="center">
              {content.title}
            </H2>
          </HideMobile>
          <ShowMobile>
            <H4 serif weight="bold" color="white" align="center">
              {content.title}
            </H4>
          </ShowMobile>
          <H3 color="white">
            {content.subtitle}
          </H3>
        </Section>
        <Section fixed>
          <Emphasis>
            <H4>
              {content.animationTitle}
            </H4>
          </Emphasis>
        </Section>
        <HideMobile>
          <ProductAnimationSlider
            animationTitles={[
              content.animationTitle1,
              content.animationTitle2,
              content.animationTitle3,
              content.animationTitle4
            ]}
            animationDescriptions={[
              content.animationDescription1.animationDescription1,
              content.animationDescription2.animationDescription2,
              content.animationDescription3.animationDescription3,
              content.animationDescription4.animationDescription4
            ]}
          />
        </HideMobile>
        <ShowMobile>
          <ProductAnimationMobile
            animationTitles={[
              content.animationTitle1,
              content.animationTitle2,
              content.animationTitle3,
              content.animationTitle4
            ]}
            animationDescriptions={[
              content.animationDescription1.animationDescription1,
              content.animationDescription2.animationDescription2,
              content.animationDescription3.animationDescription3,
              content.animationDescription4.animationDescription4
            ]}
          />
        </ShowMobile>
        <Section>
          <IconGrid benefits={content.benefitList} />
        </Section>
        <Couple visible={true} content={missionContent} />
        <ContentSection
          join
          color="greyLight"
          titleText={content.missionTitle}
          bodyText={content.missionBodyText.missionBodyText.split("|")}
          link={{
            label: content.missionLink,
            to: "/mission"
          }}
        />
      </div>
    );
  }
}

export const pageQuery = graphql`
  query ProductPageQuery {
    allContentfulProductPage {
      edges {
        node {
          id
          title
          animationTitle
          benefitTitle
          missionTitle
          missionBodyText {
            missionBodyText
          }
          benefitList {
            title
            icons {
              src
              tag
              description
            }
          }
          missionLink
          animationTitle1
          animationTitle2
          animationTitle3
          animationTitle4
          animationDescription1 {
            animationDescription1
          }
          animationDescription2 {
            animationDescription2
          }
          animationDescription3 {
            animationDescription3
          }
          animationDescription4 {
            animationDescription4
          }
        }
      }
    }
    allContentfulMissionPage {
      edges {
        node {
          coupleImage {
            responsiveResolution(width: 800, quality: 70) {
              src
            }
          }
          maleTitle
          maleBody {
            maleBody
          }
          femaleTitle
          femaleBody {
            femaleBody
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/product.js